import toast from 'src/components/common/toast';

interface IUpdateNumProps {
    stock: number;
    currentNum: number;
    targetNum: number;
    input: boolean;
    limitNumber?: boolean;
    onNumUpdated: (num: number) => void;
}
export const updateBuyNum = ({
    stock,
    currentNum,
    input,
    limitNumber,
    onNumUpdated,
    targetNum
}: IUpdateNumProps) => {
    if (limitNumber && targetNum !== 1) {
        toast('只能购买 1 件');
        return onNumUpdated(1);
    }
    if (targetNum === 0 && input) return onNumUpdated(0);
    // stock可能为0，编辑数量最小为1
    if (targetNum > currentNum && targetNum > Math.max(stock, 1))
        return toast(`最多购买 ${Math.max(currentNum, stock, 1)} 件`);

    if (targetNum < 1) return toast(`最少购买 1 件`);

    onNumUpdated(targetNum);
};

export const numberWrapper = (num: number) => (num && num >= 0 ? num : 0);
